module.exports = __webpack_public_path__ + "img/a-ziyuan9.c59b2340.png";